import React, { useMemo } from 'react';
import { Metric } from 'hooks/search';
import { Container } from './styles';
import SectionTitle from 'components/SectionTitle';
import { useIntl } from 'react-intl';
import MostCitedTermsWrapper from './MostCitedTermsWrapper';
import useDefaultChartsContainer from 'hooks/defaultChartsContainer';
import { useAuth } from 'hooks/auth';

const MostCitedTermsContainer: React.FC = () => {
  const intl = useIntl();
	const { isUserLogged } = useAuth();

	const services = useMemo(() => {
		if (!isUserLogged) return ['facebook', 'instagram', 'misc'];
		return ['facebook', 'instagram', 'twitter', 'misc'];
	}, [isUserLogged]);

  const { paramsDatas, loading, searchedTerms } = useDefaultChartsContainer(
	'/historical_volume.json',
	{
		grouping: 'term',
		service: services
	},
  );

  const groupedTerms = (metrics: Metric[]) => {
	const grouped = Object.entries(
	  metrics.reduce((acc: Record<string, number>, item) => {
	    acc[item.label] = (acc[item.label] || 0) + item.value;
	      return acc;
	    }, {})
	  ).map(([key, value]) => ({
	    name: key,
		value,
	  })
	);
	return grouped;
  };

  return (
    <>
      <Container
        title={[
          <header key="header">
            <SectionTitle>
              {intl.formatMessage({ id: 'results.most-cited-terms' })}
            </SectionTitle>
          </header>,
        ]}
      >
        {paramsDatas && searchedTerms.map(item => {
	  	  const key = item.obligatory;
	  	  const metrics = paramsDatas.get(key) as Metric[];
	  	  const grouped = metrics ? groupedTerms(metrics) : [];
  
	  	  return metrics ? (
	  	    <div key={`fragment-${key}`}>
	  		  <MostCitedTermsWrapper
	  		    title={key}
	  		    key={key}
	  		    data={grouped}
	  		  />
	  		</div>
	  		) : null;
	  	})}
      </Container>
    </>
  );
};

export default MostCitedTermsContainer;
